import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  //定义路由
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/LPG/echart/EchartView.vue')
  },
  {
    path: '/chronic',
    name: 'chronic',
    component: () => import('../views/LPG/chronic/ChronicView.vue')
  },
  {
    path: '/',
    redirect: '/index'
  }
]

const router = new VueRouter({
  routes
})

export default router
